import * as React from 'react';
import { ModalConsumer } from './Contexts/ModalContext';

export default function withModal(Component) {
  return function ModalAwareComponent(props) {
    return (
      <ModalConsumer>
        {({ showModal, hideModal }) => (
          <Component {...props} showModal={showModal} hideModal={hideModal} />
        )}
      </ModalConsumer>
    );
  };
}
